import { useLocation } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
// project imports
import LogoSection from '../LogoSection';
import SearchSection from './SearchSection';
import MobileSection from './MobileSection';
import ProfileSection from './ProfileSection';
import LiveCustomizeSection from './LiveCustomizeSection';
import MegaMenuSection from './MegaMenuSection';
import FullScreenSection from './FullScreenSection';
import NotificationSection from './NotificationSection';
import LocalizationSection from './LocalizationSection';
import SupportSection from './SupportSection';
import AccountContextSection from './AccountContextSection';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import { MenuOrientation, ThemeMode } from 'config';
import useConfig from 'hooks/useConfig';
import useDashboardTour from 'hooks/useDashboardTour';

// assets
import { IconMenu2 } from '@tabler/icons-react';
import headerPattern from 'assets/images/header-pattern_org.svg';
// ==============================|| MAIN NAVBAR / HEADER ||============================== //

export default function Header({ startTour }) {
  const theme = useTheme();
  const downMD = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();
  const isNewLoginPage = location.pathname === '/newLogin' || location.pathname.endsWith('/newLogin');

  const { mode, menuOrientation } = useConfig();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;
  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downMD;
  return (
    <>
      {/* logo & toggler button */}
      <Box sx={{ width: downMD ? 'auto' : 250, display: 'flex' }}>
        <Box component="span" sx={{ display: { xs: 'none', md: 'flex' }, flexGrow: 1, alignItems: 'center', mt: .75, mr: 3.3, ...(isNewLoginPage && { pointerEvents: 'none' }) }}>
          <LogoSection />
        </Box>
        <Box component="span" sx={{ display: { xs: 'none', md: 'flex' }, flexGrow: 1, alignItems: 'flex-start' }}>
          <img src={headerPattern} alt='header-pattern'/>
        </Box>
        {!isHorizontal && (
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              overflow: 'hidden',
              transition: 'all .2s ease-in-out',
              bgcolor: 'teal.800',
              color: 'white.paper',
              display: { xs: 'flex', md: 'none'}
            }}
            onClick={() => handlerDrawerOpen(!drawerOpen)}
            color="inherit"
          >
            <IconMenu2 stroke={2} size="22px" />
          </Avatar>
        )}
      </Box>
      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0,
          minWidth: 0,
        }}
      >
        {!isNewLoginPage && (
          <Box sx={{ flexShrink: 0, mr: { md: 2 } }}>
            <SearchSection />
          </Box>
        )}
        <LocalizationSection />
        {!isNewLoginPage && <NotificationSection />}
        {!isNewLoginPage && <LiveCustomizeSection />}
        {!isNewLoginPage && <SupportSection startTour={startTour} />}
        <ProfileSection />
        <AccountContextSection />
      </Box>
      {/* mobile header */}
      <Box sx={{ display: { xs: 'none', sm: 'none' } }}>
        <MobileSection />
      </Box>
    </>
  );
}
